import { render, staticRenderFns } from "./byFold.vue?vue&type=template&id=3486f510&scoped=true"
import script from "./byFold.vue?vue&type=script&lang=js"
export * from "./byFold.vue?vue&type=script&lang=js"
import style0 from "./byFold.vue?vue&type=style&index=0&id=3486f510&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3486f510",
  null
  
)

export default component.exports